export default "__VITE_ASSET__d621b9b6__"